<template>
  <v-navigation-drawer
    :value="isPaymentLimiterConfigOpen"
    :permanent="isPaymentLimiterConfigOpen"
    width="800px"
    max-width="100vw"
    right
    fixed
    temporary
    style="z-index: 11;transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        :button-save="!!payload.id"
        @close="close"
        @save="submitData"
        title="PaymentLimiter"
        type-title="icon"
        icon="edit"
        :loader-save="submitLoading"
        buttonSave
      />
      <v-progress-linear
        v-if="loading"
        indeterminate
        height="5"
        class="my-0"
      />
      <v-card-text v-else style="overflow-y: auto;height: calc(100vh - 64px)">
        <v-container class="pa-5">
          <v-row justify="center">
            <v-col
              :cols="payload.ban_type === 'temporary' ? 6 : 12"
              :sm="payload.ban_type === 'temporary' ? 5 : 10"
            >
              <v-select
                v-model="payload.ban_type"
                :items="banTypes"
                label="Tipo de baneo"
                v-validate="'required'"
                data-vv-name="Tipo de baneo"
                :error-messages="errors.collect('Tipo de baneo')"
              ></v-select>
            </v-col>
            <!-- <v-col cols="12" sm="10">
              <v-text-field
                v-model="payload.ban_message"
                type="text"
                label="Mensaje de baneo"
                v-validate="'required'"
                data-vv-name="Mensaje de baneo"
                :error-messages="errors.collect('Mensaje de baneo')"
                required
              />
            </v-col> -->
            <v-col v-if="payload.ban_type === 'temporary'" cols="6" sm="5">
              <v-text-field
                v-model="payload.ban_time"
                type="number"
                label="Tiempo de baneo"
                suffix="minutos"
                v-validate="'required'"
                data-vv-name="Tiempo de baneo"
                :error-messages="errors.collect('Tiempo de baneo')"
                required
              />
            </v-col>
            <v-col cols="6" sm="5">
              <v-text-field
                v-model="payload.attempts"
                type="number"
                label="Número de intentos"
                v-validate="'required'"
                data-vv-name="Número de intentos"
                :error-messages="errors.collect('Número de intentos')"
                required
              />
            </v-col>
            <v-col cols="6" sm="5">
              <v-text-field
                v-model="payload.attempts_time"
                type="number"
                label="Tiempo para intentos"
                suffix="minutos"
                v-validate="'required'"
                data-vv-name="Tiempo para intentos"
                :error-messages="errors.collect('Tiempo para intentos')"
                required
              />
            </v-col>
            <v-col cols="12" sm="10">
              <v-switch
                v-model="payload.status"
                inset
                color="primary"
                true-value="enabled"
                false-value="disabled"
                label="Activar Payment limiter"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="10">
              <v-card>
                <v-card-title class="title primary--text pa-4">
                  Mensaje de baneo (Idiomas)
                </v-card-title>
                <v-divider />
                <v-card-text class="pa-8">
                  <v-form data-vv-scope="formTranslation">
                    <v-row>
                      <v-col cols="12" class="d-flex align-center">
                        <v-autocomplete
                          v-model="messageTranslation.language_code"
                          :items="avaliableLanguages"
                          label="Idioma"
                          v-validate="'required'"
                          data-vv-name="Idioma"
                          :error-messages="errors.collect('formTranslation.Idioma')"
                          required
                          outlined
                          class="mr-4 pt-8"
                          style="width: 206px;"
                        />
                        <v-text-field
                          v-model="messageTranslation.message"
                          type="text"
                          label="Mensaje de baneo"
                          v-validate="'required'"
                          data-vv-name="Mensaje de baneo"
                          :error-messages="errors.collect('formTranslation.Mensaje de baneo')"
                          required
                          outlined
                          class="mr-4 pt-8"
                        />
                        <v-btn
                          color="primary"
                          fab
                          small
                          @click="pushBanMessage"
                        >
                          <v-icon>add</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-divider />
                <v-card-text v-if="payload.translations.length" class="pa-8 overflow-y-auto" style="max-height: 400px;">
                  <v-row>
                    <v-col
                      v-for="(item, index) in payload.translations"
                      :key="item.language_code"
                      cols="12"
                      class="d-flex align-center"
                    >
                      <div class="d-flex align-center justify-center" style="width: 56px; height: 56px;">
                        <v-checkbox
                          v-model="item.is_default"
                          size="xl"
                          style="height:24px; width: 24px;"
                          hide-details
                          class="pa-0 ma-0"
                          :readonly="item.is_default"
                          @change="setDefaultBanMessage(index)"
                        ></v-checkbox>
                      </div>
                      <v-autocomplete
                        v-model="item.language_code"
                        :items="avaliableLanguages"
                        label="Idioma"
                        outlined
                        class="mr-4"
                        hide-details
                        readonly
                        style="width: 150px;"
                      />
                      <v-text-field
                        v-model="item.message"
                        type="text"
                        label="Mensaje de baneo"
                        outlined
                        class="mr-4"
                        hide-details
                        readonly
                      />
                      <v-btn
                        color="error"
                        fab
                        small
                        :disabled="item.is_default"
                        @click="removeBanMessage(index)"
                      >
                        <v-icon>remove</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text v-else class="pa-4">
                  <div class="text-center my-8">
                    <v-img
                      :src="require('@/assets/svg/box_empty.svg')"
                      height="150"
                      max-height="150px"
                      aspect-ratio="1"
                      contain
                    />
                    <div class="grey--text subtitle-1">
                      {{ $t('common.no_results_found') }}
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import config from '@/config'
import BaseToolbar from '@/components/BaseToolbar.vue'
import { organizationService } from '@/services/organization.service'
import languages from '@/data/languages.json'

export default {
  name: 'PaymentLimiter',
  components: {
    BaseToolbar
  },
  data () {
    return {
      loading: false,
      submitLoading: false,
      url: config.b_path,
      banTypes: [
        { text: 'Temporal', value: 'temporary' },
        { text: 'Permanente', value: 'permanent' }
      ],
      payload: {
        status: 'disabled',
        attempts: null,
        attempts_time: null,
        ban_type: 'temporary',
        ban_time: null,
        ban_message: null,
        translations: []
      },
      messageTranslation: {
        is_default: false,
        language_code: null,
        message: null
      }
    }
  },
  watch: {
    async isPaymentLimiterConfigOpen (newVal) {
      if (newVal) {
        this.loading = true
        await this.getDataFromServer()
        this.loading = false
      }
    }
  },
  computed: {
    ...mapState({
      orgId: ({ organization: { orgId } }) => orgId,
      addons: ({ organization: { addons } }) => addons,
      organization: ({ organization: { organization } }) => organization
    }),
    ...mapGetters({
      isPaymentLimiterConfigOpen: 'organization/isPaymentLimiterConfigOpen'
    }),
    paymentLimiterAddon () {
      return this.addons.find(addon => addon.name.toLowerCase() === 'paymentlimiter')
    },
    avaliableLanguages () {
      return languages.map(e => {
        return {
          text: e.name,
          value: e.code,
          disabled: this.payload.translations.some(item => item.language_code.toLowerCase() === e.code.toLowerCase())
        }
      })
    }
  },
  methods: {
    ...mapActions({
      setUser: 'localStorage/setUser'
    }),
    ...mapMutations({
      togglePaymentLimiterConfig: 'organization/togglePaymentLimiterConfig'
    }),
    close () {
      this.togglePaymentLimiterConfig(false)
      this.cleanData()
    },
    async getDataFromServer () {
      try {
        const organizationAddon = (
          await organizationService.getOrganizationAddon(this.orgId, this.paymentLimiterAddon.id)
        ).data
        this.setPayload({
          ...this.payload,
          ...organizationAddon.json_config
        })
      } catch (error) {
        console.log(error)
      }
    },
    setPayload (newPayload) {
      this.payload = newPayload
    },
    async submitData () {
      const isValid = await this.$validator.validateAll()

      if (!isValid) {
        return
      }

      if (this.payload.translations.length === 0) {
        this.$noty.error('Debe agregar al menos un mensaje de baneo')
        return
      }

      this.submitLoading = true

      const {
        orgId,
        payload,
        paymentLimiterAddon
      } = this

      try {
        await organizationService.updateOrganizationAddon(orgId, {
          addon_id: paymentLimiterAddon.id,
          json_config: payload,
          status: true
        })
        this.$noty.success('Payment limiter actualizado')
      } catch (error) {
        console.log(error)
        this.$noty.error('Error al actualizar')
      }
      this.submitLoading = false
    },
    cleanData () {
      this.loading = false
      this.submitLoading = false
      this.payload = {
        status: 'disabled',
        attempts: null,
        attempts_time: null,
        ban_type: 'temporary',
        ban_time: null,
        ban_message: null,
        translations: []
      }
      this.$validator.reset()
    },
    setDefaultBanMessage (index) {
      this.payload.translations.forEach(item => {
        item.is_default = false
      })
      this.payload.translations[index].is_default = true
    },
    async pushBanMessage () {
      const isValid = await this.$validator.validateAll('formTranslation')
      if (!isValid) {
        return
      }
      this.payload.translations.push(this.messageTranslation)
      if (this.payload.translations.length === 1) {
        this.payload.translations[0].is_default = true
      }
      this.messageTranslation = {
        is_default: false,
        language_code: null,
        message: null
      }
      this.$validator.reset()
    },
    removeBanMessage (index) {
      this.payload.translations.splice(index, 1)
    }
  }
}
</script>
